import React from 'react'

const Access = () => {
  return (
    <div className='w-full  bg-white'>
        
      
    </div>
  )
}

export default Access
